import React from 'react';

const SectionHeading = ({ eyebrow, title, subtitle, align = 'center', className = '' }) => {
  const isCenter = align === 'center';

  return (
    <div
      className={`flex flex-col mb-10 md:mb-14 ${isCenter ? 'items-center text-center' : 'items-start text-left'} ${className}`}
      data-aos="fade-up"
    >
      {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
      <h2 className="section-title">{title}</h2>
      <span className={`section-title-bar ${isCenter ? '' : 'ml-0'}`} />
      {subtitle && (
        <p className={`section-subtitle ${isCenter ? 'mx-auto' : ''}`}>{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
